import axios from 'axios';
import {useEffect, useState} from 'react'

const memoryCache = new Map();
const inflightRequests = new Map();

const useFetch = (url,autoLoad=true, options = {}) => {
    const [data,setData] = useState(null);
    const [loading,setLoading] = useState(Boolean(autoLoad && url));
    const [error,setError]  = useState(null);
    const cacheTimeMs = Number(options.cacheTimeMs ?? 30_000);

    const fetchData = async (overrideUrl = url, fetchOptions = {})=>{
        const token = localStorage.getItem('token');
        const keyUrl = overrideUrl ?? url;
        if(!keyUrl){
            setLoading(false);
            return null;
        }

        const cacheKey = token ? `${token}::${keyUrl}` : keyUrl;
        const force = Boolean(fetchOptions.force);
        if (force) {
            memoryCache.delete(cacheKey);
        }
        setLoading(true);
        try {
            const cached = memoryCache.get(cacheKey);
            const now = Date.now();
            if (!force && cacheTimeMs > 0 && cached && (now - cached.ts) < cacheTimeMs) {
                setData(cached.data);
                setLoading(false);
                return cached.data;
            }

            const existingInflight = inflightRequests.get(cacheKey);
            if (existingInflight) {
                const sharedData = await existingInflight;
                setData(sharedData);
                setLoading(false);
                return sharedData;
            }

            const requestPromise = axios
                .get(keyUrl,{
                    headers:{
                        'Authorization': `Bearer ${token}` 
                    }
                })
                .then((response) => response.data)
                .finally(() => {
                    inflightRequests.delete(cacheKey);
                });

            inflightRequests.set(cacheKey, requestPromise);
            const nextData = await requestPromise;
            memoryCache.set(cacheKey, { ts: now, data: nextData });
            setData(nextData);
            setLoading(false);
            return nextData;
        }catch(error){
            setError(error);
            setLoading(false);
            return null;
        }
    };

    const refreshHandler = () => {
        return fetchData(url, { force: true });
    }

    useEffect(()=>{
        if(autoLoad && url ){
            fetchData(url);
            return () => {
                // Cleanup or cancel ongoing requests if needed
            }
        }
    },[url])
    const isLoadingCurrentUrl = Boolean(autoLoad && url && data === null && !error);

    return {data,loading: loading || isLoadingCurrentUrl,error,fetchData,refreshHandler}
}

export default useFetch
